module.exports = __webpack_public_path__ + "logo.png?78a593f46b2167cfabab5084b28ebf67";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 18
// module chunks = 0